import { useState, useEffect } from "react";
import { getAvailableDates, newAppointment } from "../../api/api";
import imageAlejandria from "../../components/assets/Alejandria-Logo.png";
import gif from "../../components/assets/j.gif";
import FourthQuestionComponent from "./fourthquestion";
import ModalComponent from "./modalConfirm";
import ModalFinalResponseComponent from "./modalFinalResponse";
import OldPatientComponent from "./oldPatient";
import SecondQuestionComponent from "./secondQuestion";
import "./styles.css";

const AppointmentPlastic = () => {
  const [currentQuestion, setCurrentQuestion] = useState(4);
  const [responseAvailableDates, setResponseAvailableDates] = useState({});
  const [appointmentSelected, setAppointmentSelected] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [finalResponse, setFinalResponse] = useState();
  const [reasonSelected, setReasonSelected] = useState({
    id: "069",
    duration: 45,
    title: "Primera visita cirugía plástica",
  });
  const [showModalFinalResponse, setShowModalFinalResponse] = useState(false);
  const [modalConfirmAppointemnt, setModalConfirmAppointemnt] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [boolConfirmAppointment, setBoolConfirmAppointment] = useState(false);
  const [infoPatient, setInfoPatient] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    nif: "",
  });
  const [appointment, setAppointment] = useState({
    idCl: "",
    idDrList: "-1",
    idDr: "",
    idMo: "069",
    idEs: "04",
    ct_fpre: "",
    ct_hpre: "",
    duration: 45,
    observations: "",
    clientWeb: true,
  });

  useEffect(() => {
    // Cargar fechas disponibles al iniciar con los valores hardcodeados
    const initialAppointmentData = {
      idCl: "",
      idDrList: "-1",
      idDr: "",
      idMo: "069",
      idEs: "04",
      ct_fpre: "",
      ct_hpre: "",
      duration: 45,
      observations: "",
      clientWeb: true,
    };

    setIsLoading(true);
    getAvailableDates(infoPatient, onResponse, onError, initialAppointmentData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openModalInfoPatientAndAppointment = () => {
    // En lugar de abrir el modal, pasar a question 2
    setCurrentQuestion(2);
  };

  const confirmAppointmentAfterPatientData = () => {
    // Ahora sí abrimos el modal de confirmación
    setModalConfirmAppointemnt(true);
  };

  const closeModalInfoPatientAndAppointment = () => {
    setModalConfirmAppointemnt(false);
  };

  const openModalFinalResponse = () => {
    setShowModalFinalResponse(true);
  };

  const closeModalFinalResponse = () => {
    setShowModalFinalResponse(false);
  };

  const onChangeInfoPatient = (updatedValue) => {
    setInfoPatient((prevInfo) => ({
      ...prevInfo,
      name: updatedValue.name,
      phoneNumber: updatedValue.phoneNumber,
      email: updatedValue.email,
      nif: updatedValue.nif,
    }));
  };

  const appointmentSelectedByClickOnCard = (appointment) => {
    const hour = appointment.hour.split(" - ")[0];
    setAppointment((prevInfo) => ({
      ...prevInfo,
      idDr: appointment.doctor.id,
      ct_fpre: appointment.date,
      ct_hpre: hour,
    }));
  };

  const callApiDates = (newIdsModalityAndReason) => {
    setIsLoading(true);
    getAvailableDates(
      infoPatient,
      onResponse,
      onError,
      newIdsModalityAndReason,
    );
  };

  const callApiConfirmAppointment = () => {
    setIsLoadingModal(true);
    newAppointment(infoPatient, appointment, onResponseConfirm, onError, "P");
  };

  const onResponse = (response) => {
    setIsLoading(false);
    setResponseAvailableDates(JSON.parse(response));
  };

  const onResponseConfirm = (response) => {
    const responseOnConfirm = JSON.parse(response);
    if (responseOnConfirm.message) {
      // Éxito: redirigir inmediatamente sin actualizar estado
      window.location.href =
        "https://clinicaalejandria.es/cirugia-plastica-cita-confirmada/";
    } else {
      // Error: mostrar modal con mensaje de error
      setBoolConfirmAppointment(false);
      setFinalResponse(responseOnConfirm);
      setIsLoadingModal(false);
      closeModalInfoPatientAndAppointment();
      openModalFinalResponse();
    }
  };

  const onError = (error) => {
    setIsLoading(false);
    console.log("Error", error);
    window.location.href = "https://clinicaalejandria.es/";
  };

  const onClickModalError = () => {
    setShowErrorModal(false);
    setCurrentQuestion(5);
  };

  const onClickBtnFinalModal = () => {
    closeModalFinalResponse();
    callApiDates(appointment);
  };

  const renderCurrentQuestion = () => {
    switch (currentQuestion) {
      case 2:
        return (
          <SecondQuestionComponent
            onChangeInfoPatient={onChangeInfoPatient}
            callApiValidator={confirmAppointmentAfterPatientData}
            infoPatient={infoPatient}
            setInfoPatient={setInfoPatient}
          />
        );
      case 4:
        return responseAvailableDates ? (
          <FourthQuestionComponent
            responseAvailableDates={responseAvailableDates}
            setAppointmentSelected={setAppointmentSelected}
            appointmentSelected={appointmentSelected}
            openModalInfoPatientAndAppointment={
              openModalInfoPatientAndAppointment
            }
            appointmentSelectedByClickOnCard={appointmentSelectedByClickOnCard}
            reasonSelected={reasonSelected}
          />
        ) : null;
      default:
        return null;
    }
  };

  return (
    <div className="appointmentContainer">
      <img className="imageAlejandria" src={imageAlejandria} />
      {currentQuestion === 5 ? (
        <OldPatientComponent setCurrentQuestion={setCurrentQuestion} />
      ) : (
        <div className="newAppointmentNewPatient">
          {isLoading ? (
            <div className="loadingContainer">
              <img src={gif} alt="Loading" className="loadingGif" />
            </div>
          ) : (
            renderCurrentQuestion()
          )}
        </div>
      )}
      {modalConfirmAppointemnt && (
        <ModalComponent
          appointmentSelected={appointmentSelected}
          closeModalInfoPatientAndAppointment={
            closeModalInfoPatientAndAppointment
          }
          callApiConfirmAppointment={callApiConfirmAppointment}
          setAppointment={setAppointment}
          appointment={appointment}
          isLoadingModal={isLoadingModal}
        />
      )}
      {showModalFinalResponse && (
        <ModalFinalResponseComponent
          finalResponse={finalResponse}
          closeModalFinalResponse={closeModalFinalResponse}
          boolConfirmAppointment={boolConfirmAppointment}
          onClickBtnFinalModal={onClickBtnFinalModal}
        />
      )}
      {showErrorModal && (
        <div className="errorModal">
          <div className="errorModalContent">
            <h2 className="titleErrorModal">Upps!!</h2>
            <p className="contentErrorModal">{errorMessage}</p>
            <button className="btnErrorModal" onClick={onClickModalError}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentPlastic;
